// extracted by mini-css-extract-plugin
module.exports = {"container":"NewsCallToAction_container__AhlwU","card":"NewsCallToAction_card__1JUkx"};